import React from 'react';
import { Link } from 'react-router-dom';
import type { PublicFiche } from '../types';
import { CardHeader }  from './sections/CardHeader';
import { CardBadges }  from './sections/CardBadges';
import { CardProbleme } from './sections/CardProbleme';
import { CardFooter }  from './sections/CardFooter';

export interface FicheCardBaseProps {
  fiche:          PublicFiche;
  showScore?:     boolean;
  compact?:       boolean;
  /**
   * Variante de bordure gauche :
   * - 'default'  → hover bleu (Cass./générique)
   * - 'principe' → amber (arrêt de principe)
   * - 'rgpd'     → bleu RGPD
   */
  borderVariant?: 'default' | 'principe' | 'rgpd';
  /** Sections spécialisées injectées entre Problème et Footer */
  children?:      React.ReactNode;
}

const VARIANT_CLS = {
  default:  'hover:border-sl-blue-m hover:shadow-md',
  principe: 'border-amber-200 dark:border-amber-800 border-l-4 border-l-amber-400 hover:border-amber-300 hover:bg-amber-50/20 dark:hover:bg-amber-900/10',
  rgpd:     'border-blue-200 dark:border-blue-800 border-l-4 border-l-blue-500 hover:border-blue-300 hover:shadow-md',
} as const;

export const FicheCardBase = ({
  fiche,
  showScore    = false,
  compact      = false,
  borderVariant = 'default',
  children,
}: FicheCardBaseProps) => (
  <Link
    to={`/jurisprudence/${fiche.slug}`}
    className={`group block rounded-xl border bg-card transition-all duration-200 ${VARIANT_CLS[borderVariant]}`}
  >
    <CardHeader  fiche={fiche} />
    <CardBadges  fiche={fiche} showScore={showScore} />
    <CardProbleme fiche={fiche} />
    {children}
    <CardFooter  fiche={fiche} compact={compact} />
  </Link>
);